// src/lib/utils.js
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, options = {}) {
  const { showSign = false, compact = false } = options;
  const abs = Math.abs(amount);
  let formatted;

  if (compact && abs >= 1000) {
    formatted = "$" + (abs / 1000).toFixed(1) + "k";
  } else {
    formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(abs);
  }

  if (showSign) {
    return amount >= 0 ? `+${formatted}` : `-${formatted}`;
  }
  return amount < 0 ? `-${formatted}` : formatted;
}

export function formatPercent(value, showSign = true) {
  const formatted = Math.abs(value).toFixed(1) + "%";
  if (showSign) return value >= 0 ? `+${formatted}` : `-${formatted}`;
  return formatted;
}

export function formatDate(date, fmt = "MMM d") {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  if (fmt === "MMM d") return `${months[d.getMonth()]} ${d.getDate()}`;
  if (fmt === "MMM yyyy") return `${months[d.getMonth()]} ${d.getFullYear()}`;
  if (fmt === "MMM d, yyyy") return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  return d.toLocaleDateString();
}

export function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function calcNetWorthBreakEven(netWorth, weeklyChange) {
  if (netWorth >= 0 || weeklyChange <= 0) return null;
  const weeksToBreakEven = Math.abs(netWorth) / weeklyChange;
  const breakEvenDate = new Date();
  breakEvenDate.setDate(breakEvenDate.getDate() + weeksToBreakEven * 7);
  return breakEvenDate;
}

export function calcLoanPayoff(balance, rate, monthlyPayment) {
  if (monthlyPayment <= 0) return null;
  const monthlyRate = rate / 100 / 12;
  let bal = balance;
  let months = 0;
  while (bal > 0 && months < 600) {
    const interest = bal * monthlyRate;
    bal = bal + interest - monthlyPayment;
    months++;
    if (bal < 0) bal = 0;
  }
  const payoffDate = new Date();
  payoffDate.setMonth(payoffDate.getMonth() + months);
  return payoffDate;
}
